import React from 'react'
import { connect } from 'react-redux'
import { Page } from '../../../components/page/Page'
import { routes, enums } from '../../../constants'
import storage from '../../../services/stoage.service'
import utils from '../../../utils'
import { actions } from '../dre.actions'
import { DREForm } from './DREForm'
import { Button } from 'primereact/button'
import { DefaultToolBar } from '../../../components/toolbar/DefaultToolBar'
import * as listPageUtils from '../../../utils/listPageContainerUtils'
import { logarAcesso } from '../../../services/api-log-acesso'
import { AgendarRelatorioDialog } from '../../../components/agendamentoRelatorio/AgendarRelatorioDialog'
import { FiltrosSalvosRelatorio } from '../../../components/agendamentoRelatorio/FiltrosSalvosRelatorio'
import { podeAgendar } from '../../../components/agendamentoRelatorio/agendamentoRelatorio.utils'
import { getRelatorioAgendavel } from '../../../components/agendamentoRelatorio/relatoriosAgendaveis'
import { aplicarPreparado } from '../../../components/agendamentoRelatorio/padraoNaTela'
import { nomeRelatorio, textoAgendamento } from '../../../components/agendamentoRelatorio/textos'
import { messageActions } from '../../../store/message'

const mapStateToProps = (state) => {
  const messages = state.crudDREState.messages
  const record = state.crudDREState.currentRecord

  // REFERENTE AO DROPDOWN DE UNIDADES
  let disableUnit = false
  let currentUnit = storage.getUnit()
  if (currentUnit) {
    // no campo que o seletor, o Visualizar e o Agendar leem ({ id, label }); em 'unidades' ninguem lia, ia vazio e
    // o back usava todas as unidades da empresa
    let unidade = {
      id: currentUnit.oid,
      label: currentUnit.sigla,
    }
    Object.assign(record, { unidade: [unidade] })
    disableUnit = true
  }

  let unidades = []
  let unidadesEmpresa = utils.getListIdValuesUnidadeFromEmpresa(storage.getCompany())
  unidades = unidades.concat(unidadesEmpresa)
  return {
    record,
    messages,
    unidades,
    disableUnit,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    paginate: (paginationParams) => dispatch(actions.paginate(paginationParams)),
    sortOrder: (sortParams) => dispatch(actions.sortOrder(sortParams)),
    applyFilter: (filterParams) => {
      dispatch(actions.setType(null))
      dispatch(actions.applyFilter(filterParams))
    },
    setField: (field, value) => dispatch(actions.setField(field, value)),
    changeHandler: (event) => {
      const target = event.target
      const field = target.name
      let valor = target.value
      dispatch(actions.removeErrors([{ field }]))
      dispatch(actions.setField(field, valor))
    },
    onClickBotaoDinamico: (listId, oidBotao) => dispatch(actions.executarFuncaoDinamica(listId, oidBotao)),
    saveHandler: (event) => dispatch(actions.save()),
    removeHandler: (event) => dispatch(actions.remove()),
    newHandler: (event) => dispatch(actions.makeNew()),
    loadById: (oid) => dispatch(actions.loadById(oid)),
    loadFavorito: (menu) => dispatch(actions.loadFavorito(menu)),
    removeFavorito: (menu) => dispatch(actions.removeFavorito(menu)),
    adicionarFavorito: (menu) => dispatch(actions.adicionarFavorito(menu)),
    getBotoesDinamicos: (idTela) => {
      let tipoTela = Number(enums.TipoTela.FORMULARIO)
      dispatch(actions.getBotoesDinamicos(idTela, tipoTela))
    },
    abrirRelatorio: (dataInicial, dataFinal, unidade) =>
      dispatch(actions.abrirRelatorio(dataInicial, dataFinal, unidade)),
    mostrarSucesso: (mensagem) => dispatch(messageActions.showMessages([mensagem], 'success')),
  }
}

class DREFormPageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.showPesquisarButton = false
    this.showCSVButton = false
    this.showColumnButton = false
    this.state = {
      dadosFavorito: null,
      favorito: 0,
      agendarVisivel: false,
    }
    this.podeAgendar = podeAgendar(storage.getMenus(), routes.PATH_AGENDAMENTOS_RELATORIO)
    actions.afterNew = () => {
      this.props.history.push(`${routes.PATH_DRE}`)
    }
    actions.afterLoadFavorito = (data) => {
      if (data && data.oid) {
        this.setState({ favorito: 1 })
        this.setState({ dadosFavorito: data })
      } else {
        this.setState({ favorito: 0 })
        this.setState({ dadosFavorito: null })
      }
    }
  }

  componentDidMount() {
    logarAcesso().then()
    this.props.newHandler()
    this.props.loadFavorito(this.props.history.location.pathname)
  }

  loadFavorito() {
    listPageUtils.loadFavorito(this, actions)
  }

  changeFavorito() {
    listPageUtils.changeFavorito(this, actions)
  }

  visualizarRelatorio = () => {
    const unidades = utils.convertArrayIdLabelToIdValue(this.props.record.unidade)
    this.props.abrirRelatorio(this.props.record.dataInicial, this.props.record.dataFinal, unidades)
  }

  // os mesmos filtros que o Visualizar manda, com as datas da tela
  getFiltrosAgendamento = () => ({
    unidades: utils.convertArrayIdLabelToIdValue(this.props.record.unidade) || [],
    dataInicial: this.props.record.dataInicial,
    dataFinal: this.props.record.dataFinal,
  })

  // filtro padrao (PHOENIX-107, fase 3): as unidades que o usuario ainda acessa e as datas, preparadas pelo registro
  // (relatoriosAgendaveis); a unidade do DRE nao tem cargas dependentes, vai direto pelo setField
  aplicarPadrao = (filtros, vigente) =>
    this.getDre()
      .prepararPadrao(filtros)
      .then((preparado) =>
        aplicarPreparado(preparado, vigente, ({ record }) =>
          Object.keys(record).forEach((campo) => this.props.setField(campo, record[campo]))
        )
      )

  // um por tela: le o dicionario do storage, e a tela re-renderiza a cada alteracao (Agendar e Filtros salvos usam)
  getDre = () => {
    if (!this.dre) {
      const agendavel = getRelatorioAgendavel('dre')
      this.dre = { ...agendavel, relatorio: { path: 'dre', descricao: agendavel.descricao } }
    }
    return this.dre
  }

  renderAgendar = () => {
    const dre = this.getDre()
    return (
      <AgendarRelatorioDialog
        visible={this.state.agendarVisivel}
        onHide={() => this.setState({ agendarVisivel: false })}
        relatorio={dre.relatorio}
        camposData={dre.camposData}
        EditorFiltros={dre.EditorFiltros}
        filtrosTela={this.getFiltrosAgendamento()}
        onSaved={() => this.props.mostrarSucesso(textoAgendamento('agendado'))}
      />
    )
  }

  getCustomButtons = () => {
    const dre = this.getDre()
    return (
      <div className="p-toolbar-group-left">
        <Button label="Visualizar" icon="pi pi-check" className="p-button-success" onClick={this.visualizarRelatorio} />
        {this.podeAgendar && (
          <Button
            label={textoAgendamento('agendar')}
            icon="pi pi-clock"
            className="p-button-secondary"
            style={{ marginLeft: '.25em' }}
            onClick={() => this.setState({ agendarVisivel: true })}
          />
        )}
        <FiltrosSalvosRelatorio
          relatorio={dre.relatorio}
          camposData={dre.camposData}
          EditorFiltros={dre.EditorFiltros}
          filtrosDaTela={this.getFiltrosAgendamento}
          aplicarPadrao={this.aplicarPadrao}
        />
      </div>
    )
  }

  onChangeUnit = (e) => {
    const target = e.target
    const field = target.name
    const valor = target.value
    this.props.setField(field, valor)
  }

  buildHeader = () => {
    return (
      <div>
        <DefaultToolBar listPageContainer={this} title={nomeRelatorio('dre')} />
      </div>
    )
  }

  render() {
    const content = (
      <DREForm
        visualizarRelatorio={this.visualizarRelatorio}
        currentUser={this.props.currentUser}
        messages={this.props.messages}
        changeHandler={this.props.changeHandler}
        record={this.props.record}
        disableUnit={this.props.disableUnit}
        unidades={this.props.unidades}
        onChangeUnit={this.onChangeUnit}
      />
    )

    return (
      <React.Fragment>
        <Page content={content} header={this.buildHeader()} />
        {this.podeAgendar && this.renderAgendar()}
      </React.Fragment>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DREFormPageContainer)
